import React from 'react'

function Ipad() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is Ipad page</h1>
    </div>
  )
}

export default Ipad